<template>
  <span class="status-badge" :class="'tone-' + tone"><slot>{{ label }}</slot></span>
</template>

<script>
export default {
  name: "StatusBadge",
  props: {
    // success | warning | danger | neutral | gold
    tone: { type: String, default: "neutral" },
    label: { type: String, default: "" },
  },
};
</script>

<style scoped>
.status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  min-width: 76px;
  height: 26px;
  padding: 0 10px;
  border-radius: 999px;
  font: 600 12px "Geist", system-ui, sans-serif;
  white-space: nowrap;
}
.tone-success {
  background: #eaf8f1;
  color: #0f7a4f;
  box-shadow: inset 0 0 0 1px #bfe8d3;
}
.tone-warning {
  background: #fff1e2;
  color: #b4540a;
  box-shadow: inset 0 0 0 1px #fad9b0;
}
.tone-danger {
  background: #fdecec;
  color: #c42b2b;
  box-shadow: inset 0 0 0 1px #f6c9c9;
}
.tone-neutral {
  background: #f4f5f8;
  color: #6b7283;
  box-shadow: inset 0 0 0 1px #e6e8ee;
}
.tone-gold {
  background: #fff3dc;
  color: #9a6a1c;
  box-shadow: inset 0 0 0 1px #f1d9a8;
}
</style>
